module.exports = __webpack_public_path__ + "static/media/appicon.7e2d225a.png";